import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TerminationCauseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/termination-cause-dto';
import { ServiceAftaleService } from 'src/app/api/services';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
    selector: 'app-termination-reason',
    templateUrl: './termination-reason.component.html',
    styleUrls: ['./termination-reason.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TerminationReasonComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() terminationCauses: TerminationCauseDto[];
  unsubscribe$ = new Subject<void>();
  constructor() {}

  ngOnInit(): void {}

  terminationCauseChanged(value: string) {
    this.terminationCauseOther.setValidators(value === this.terminationCauseOtherName ? Validators.required : Validators.nullValidator);
    this.terminationCauseOther.updateValueAndValidity();
  }

  get terminationCause() {
    return this.form.get('terminationCause');
  }

  get terminationCauseOther() {
    return this.form.get('terminationCauseOther');
  }

  get terminationCauseOtherName(): string {
    return 'Andet';
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }
}
